export class VideoLoadingError extends Error {};

export class VideoBlockedError extends Error {};
export class VideoRatedContentError extends VideoBlockedError {};
export class VideoRatedContentMissingBirthdayError extends VideoRatedContentError {};
export class VideoRatedContentMissingPinError extends VideoRatedContentError {}
export class VideoRatedContentMissingSetPinError extends VideoRatedContentError {}

export type VideoError = VideoLoadingError | VideoBlockedError;
